import { render, staticRenderFns } from "./logic.vue?vue&type=template&id=206d1658&scoped=true"
import script from "./logic.vue?vue&type=script&lang=js"
export * from "./logic.vue?vue&type=script&lang=js"
import style0 from "./logic.vue?vue&type=style&index=0&id=206d1658&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206d1658",
  null
  
)

export default component.exports